import { HTMLAttributes } from "react";
import styled from "styled-components";
import { space, SpaceProps } from "styled-system";

export interface CardFooterProps extends SpaceProps, HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

const CardFooter = styled.div.attrs<CardFooterProps>(() => ({ p: "24px" }))<CardFooterProps>`
  border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  ${space}
`;

export default CardFooter;
